export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8739.8a1b8e9e.jpg";